import { render } from "./EditorHotspot.vue?vue&type=template&id=f4de06aa"
import script from "./EditorHotspot.vue?vue&type=script&lang=js"
export * from "./EditorHotspot.vue?vue&type=script&lang=js"

import "./EditorHotspot.vue?vue&type=style&index=0&id=f4de06aa&lang=css"

import exportComponent from "/home/runner/work/webapp/webapp/main/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__